export const URL_API_AUTENTICACAO = 'https://proppg.unilab.edu.br/forms/webservices/validar_login_institutos.php'
export const URL_API_INSTITUTO = 'https://proppg.unilab.edu.br/forms/webservices/ch_docentes.php'